import UploadImage from "components/util/editor-uploader";
import buttonTheme from "css/themes/Buttons.css";
import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-toolbox/lib/button";
import Validator from "util/form-validator";
import Field from "visual-components/util/inputs/field";

const validations = {
  ctaURL: [Validator.required],
};

class CtaSmallImage extends React.Component {
  updateCtaImage = (src) => {
    store.dispatch({
      model: "ctaModel",
      type: "UPDATE_ATTR",
      data: {
        ctaImage: src,
      },
    });
  };

  render() {
    const { dataModel: cta } = this.props;

    return (
      <div style={{ display: "inline" }}>
        <Field
          {...this.props}
          attrName="ctaUrl"
          label="Custom CTA Link"
          placeholder="http://www.companysite.com/promo"
          validations={validations.ctaURL}
        />

        <div
          style={{
            width: "112px",
            display: "inline-block",
            marginRight: "12px",
            marginTop: "-8px",
          }}
        >
          <UploadImage
            action={`/partnership-cta-image/${cta.id}`}
            src={cta.ctaImage}
            success={this.updateCtaImage}
            name="upload-cta-image"
            acceptedFiles="image/jpeg,image/png,image/gif"
          >
            <Button
              theme={buttonTheme}
              className={`${buttonTheme.greenButton} ${buttonTheme.noMargin}`}
              label="Upload Image"
              raised
            />
          </UploadImage>
        </div>
      </div>
    );
  }
}

CtaSmallImage.propTypes = {
  dataModel: PropTypes.object.isRequired,
};

export default CtaSmallImage;
